<template>
	<div class="t-page_error t-work-area_error">
		<h1>{{ pageText.title }}</h1>
		<p class="t-page_error__hint">{{ pageText.hint }}</p>
		<div class="t-page_error__buttons">
			<router-link :to="{name: 'courses'}" class="t-btn"><span>{{ pageText.coursesBtn }}</span></router-link>
			<router-link :to="'/'" class="t-btn t-btn_white"><span>{{ pageText.mainBtn }}</span></router-link>
		</div>
		<div class="t-page_error__search">
			<h2>{{ pageText.searchTitle }}</h2>
			<cmp-search :type="'search'"></cmp-search>
		</div>

		<cmp-popular-courses></cmp-popular-courses>

		<cmp-popular-teachers></cmp-popular-teachers>
	</div>
</template>

<script>
    let localeText = {
        url: process.env.NODE_ENV !== 'production' ? 'staticText/errorPage.json' : 'staticText',
        main: {
            title: "Страницы не существует",
            hint: "Возможно она была удалена или в ссылке содержится опечатка.",
            coursesBtn: "Уроки и курсы",
            mainBtn: "Главная",
            searchTitle: "Найдите интересные уроки и курсы"
        }
    };

    import {store} from '../store'

		import PopularCourses from '../vue_components/PopularCourses.vue'
		import PopularTeachers from '../vue_components/PopularTeachers.vue'

		import {mapActions} from 'vuex'

		export default {
		    data(){
		        return {
                pageText: {}
						}
				},
				components: {
						'cmp-popular-courses': PopularCourses,
						'cmp-popular-teachers': PopularTeachers
				},
        methods: {
            ...mapActions(['UpdatePreloadState']),
            Load(pageText){
                this.pageText = pageText;
                setTimeout(() => {
                    this.UpdatePreloadState(false);
                }, 500)
            }
        },
        beforeRouteLeave (to, from, next) {
            this.UpdatePreloadState(true);
            next();
        },
				beforeRouteEnter (to, from, next) {
            let count = 0;

            let pageText = {};

            store.dispatch('staticText/LoadPageText', localeText).then((data) => {
                pageText = data;

                count++;
                RunNext();
            });
            store.dispatch('coursesList/LoadCourses', {type: 'popular'}).then(() => {
                count++;
                RunNext();
            });

            store.dispatch('teachers/LoadTeachers').then(() => {
                count++;
                RunNext();
            });

            let RunNext = () => {
                if(count > 2)
                    next(vm => vm.Load(pageText))
            }
				}
		}
</script>

<style lang="sass">
.t-page_error
	h1
		text-align: center
		font-size: 22px
		margin-bottom: 10px
	&__hint
		text-align: center
		margin-bottom: 16px
	&__buttons
		display: flex
		align-items: center
		justify-content: center
		margin-bottom: 64px
		a
			margin: 0 4px
	&__search
		background: #FFFFFF
		box-shadow: 0 24px 32px rgba(0, 108, 202, 0.1)
		border-radius: 16px
		width: 100%
		padding: 40px 120px 48px
		margin: 0 0 32px
		.t-search
			max-width: 100%
		h2
			color: $blue
			text-align: center
			font-size: 36px
			margin-bottom: 24px
	.t-courses
		margin: 0 0 32px

@media (max-width: 769px)
	.t-page_error__hint
		padding: 0 16px
	.t-page_error__buttons
		margin-bottom: 32px
	.t-page_error__search
		padding: 8px
		h2
			font-size: 22px
			padding: 0 8px
</style>


// WEBPACK FOOTER //
// src/vue_pages/E404.vue